import { Layout, theme } from "antd";

const { Content } = Layout;

export default function MyContent(props) {
  const {
    token: { colorBgContainer, borderRadiusLG },
  } = theme.useToken();

  return (
    <Layout style={{ padding: "16px" }}>
      <Content
        style={{
          padding: 16,
          margin: 0,
          minHeight: 280,
          background: colorBgContainer,
          borderRadius: borderRadiusLG,
        }}
      >
        {props.contentText}
      </Content>
    </Layout>
  );
}
